// extracted by mini-css-extract-plugin
export default {"container":"BlurColor_container__2VX8t","blurElement":"BlurColor_blurElement__ez-zf"};